import PhoneIcon from "./PhoneIcon";
import FaLocationDot from "./FaLocationDot";
import FaPhone from "./FaPhone";
import CardMultiSection from "../../Resources/components/CardMultiSection";
import { useTranslation } from "react-i18next";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { containerVariants } from "../variants";
import appConfig from "../../../utils/config/appConfig.json";
import { scrollToSection, sendWhatsappMessage } from "../../../utils";

export default function EssentialInfoCardsGroup() {    
    const { t } = useTranslation();
    const whatsappNumber = appConfig.company.whatsappNumber;
    const whatsappMessage = t("navBarItems.floatingActionShortcuts.whatsapp.defaultMessage");


    const ref = useRef(null);
    const isInView = useInView(ref, { 
        once: true, 
        amount: "all",
        margin: "100px" 
    });

    return (
        <motion.section 
            ref={ref}
            className="w-full h-auto min-h-[340.08px] sm:min-h-[117.19px] md:min-h-[126.03px] flex flex-col sm:flex-row gap-0 sm:gap-5 2xl:gap-[2vw] justify-center items-center text-black"
            variants={containerVariants}
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
            style={{ containIntrinsicSize: "333.56px" }}
        >
            <CardMultiSection 
                Icon={PhoneIcon}
                title={t("essentialInfoCardsGroup.card1.line1")}
                description={t("essentialInfoCardsGroup.card1.line2")}
                iconSize={"100%"}
                cardWidth={false}
                cardHeight={false}
                bgColor={"#FF9F0F"} 
                lineColor="#FFF"
            />
        
            <CardMultiSection 
                Icon={FaLocationDot}
                title={appConfig.company.address}
                description={t("essentialInfoCardsGroup.card2.line2")}
                iconSize={"50%"}
                cardWidth={false}
                cardHeight={false}
                bgColor={"#FF9F0F"} 
                lineColor="#FFF"
                onClick={()=>scrollToSection("location")}
                classes="cursor-pointer"
            />
        
            <CardMultiSection 
                Icon={FaPhone}
                title={appConfig.company.whatsappNumber}
                description={t("essentialInfoCardsGroup.card3.line2")}
                iconSize={"50%"}
                cardWidth={false}
                cardHeight={false}
                bgColor={"#FF9F0F"} 
                lineColor="#FFF"
                onClick={()=>sendWhatsappMessage(whatsappNumber, whatsappMessage)}
                classes="cursor-pointer"
            />
        </motion.section>
    )
}